"use client";

import React, {
  createContext,
  useContext,
  Dispatch,
  SetStateAction,
  useState,
  ReactNode,
} from "react";
import LANG from "../lang/en.json";

// Adjust based on your real structure

interface AccountBalance {
  staking: string;
  unstake: string;
  reward: string;
}

interface ContextProps {
  lang: any;
  setLang: Dispatch<SetStateAction<any>>;
  activeLang: string;
  setActiveLang: Dispatch<SetStateAction<string>>;
  accountBalance: AccountBalance;
  setAccountBalance: Dispatch<SetStateAction<AccountBalance>>;
}

const GlobalContext = createContext<ContextProps>({
  lang: {},
  setLang: () => {},
  activeLang: "en",
  setActiveLang: () => {},
  accountBalance: {
    staking: "0",
    unstake: "0",
    reward: "0",
  },
  setAccountBalance: () => {},
});

interface GlobalContextProviderProps {
  children: ReactNode;
}

export const GlobalContextProvider: React.FC<GlobalContextProviderProps> = ({
  children,
}) => {
  const [activeLang, setActiveLang] = useState<string>("en");
  const [lang, setLang] = useState<any>(LANG);
  const [accountBalance, setAccountBalance] = useState<AccountBalance>({
    staking: "0",
    unstake: "0",
    reward: "0",
  });

  return (
    <GlobalContext.Provider
      value={{
        lang,
        setLang,
        activeLang,
        setActiveLang,
        accountBalance,
        setAccountBalance,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
